export enum RegisterErrorCode {
  EmailConflict = "EMAIL_CONFLICT",
  UsernameConflict = "USERNAME_CONFLICT",
}

export enum LoginCredentialErrorCode {
  IncorrectEmail = "INCORRECT_EMAIL_OR_USERNAME",
  IncorrectPassword = "INCORRECT_PASSWORD",
}
